import React, { useState } from 'react';

import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

import PasswordChangeModal from './PasswordChangeModal/PasswordChangeModal';
import StyledButtonNE from '../../../../../shared/components/StyledButtonNE/StyledButtonNE';
import ToastNE from '../../../../../shared/components/ToastNE/ToastNE';
import {
  CLICK_ACTION,
  CHANGE_PASSWORD,
  SECTION_CONFIGURATION,
  SUB_SECTION_PASS_REQUEST
} from '../../../../../shared/constants/tagManager';
import { DEFAULT_TOAST_DATA } from '../../../../../shared/constants/toast';
import { IToast } from '../../../../../shared/interfaces/toast';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_SETTINGS } from '../../../../../shared/translations/settings';

import './Password.scss';

const Password = () => {
  const [changePassModalOpen, setChangePassModalOpen] = useState(false);
  const [changePassToast, setChangePassToast] = useState(false);
  const [toastData, setToastData] = useState<IToast>(DEFAULT_TOAST_DATA);

  const { t } = useTranslation();

  const openChangePassModal = () => {
    TagManagerService.pushEvent(CLICK_ACTION, CHANGE_PASSWORD, {
      ...SECTION_CONFIGURATION,
      ...SUB_SECTION_PASS_REQUEST
    });
    setChangePassModalOpen(true);
  };

  const handleClosedModal = (toastData?: IToast) => {
    if (toastData) {
      setToastData(toastData);
      setChangePassToast(true);
    }
    setChangePassModalOpen(false);
  };

  const handleCloseToast = () => {
    setChangePassToast(false);
  };

  return (
    <div className="settings-account-card">
      <div className="title">{t(TRANSLATIONS_SETTINGS.password.title)}</div>
      <div className="password-data-form-ne">
        <div className="password-data-form-row">
          <TextField
            variant="standard"
            className="input password"
            label={t(TRANSLATIONS_SETTINGS.password.title)}
            type="text"
            value="********"
            inputProps={{
              maxLength: 30,
              required: true
            }}
            disabled={true}
          />
        </div>
        <StyledButtonNE
          buttonType="secondary"
          classes="password-change-button"
          buttonSize="md"
          action={openChangePassModal}
        >
          {t(TRANSLATIONS_SETTINGS.password.buttonText)}
        </StyledButtonNE>
      </div>
      {changePassModalOpen && (
        <PasswordChangeModal isModalOpen={changePassModalOpen} handleCloseModal={handleClosedModal} />
      )}
      <ToastNE
        title={t(toastData.title)}
        description={t(toastData.description)}
        icon={toastData.icon}
        open={changePassToast}
        button={toastData.button}
        buttonText={t(toastData.buttonText)}
        buttonAction={handleCloseToast}
        handleClose={handleCloseToast}
      />
    </div>
  );
};

export default Password;
